import { ModalManager } from '@esign/modal';

import validation from '../components/form/validation';
import cookieNotification from '../components/cookies/cookieNotification';

// Set js class
const htmlClassList = document.documentElement.classList;
htmlClassList.add('js');
htmlClassList.remove('no-js');

window.modalManager = new ModalManager();

// Layout setup
cookieNotification();

// Forms
validation();

window.modalManager.checkModalOnPageLoad();
